import React from "react";

//interfaces
import { IBasicTextInput } from "../../../interfaces/textInputs/IBasicTextInput";



const BasicTextInput = ({id, className, labelText, labelIsHidden, placeholderText, textString, setTextString, maxLength, isDisabled, isReadOnly, type='text', autofocus=false, onReturnPressed, inputMode="text", onBlur}: IBasicTextInput) => {

    return (
        <div className={`basic-text-input-wrapper ${className ?? ""} `}>
            <label htmlFor={`basic-text-input-${id || ''}`} className={`${labelIsHidden ? "sr-only" : ""} basic-text-input-label`}>
                {labelText}
            </label>
         
            <input
                key={id ? `basic-text-input-${id}`: ''}
                type={type}
                id={`basic-text-input-${id || ''}`}
                className={"basic-text-input"}
                placeholder={placeholderText}
                value={textString}
                onChange={(e) => setTextString(e.target.value)}
                aria-label="Add your Text"
                maxLength={maxLength}
                disabled={isDisabled}
                readOnly={isReadOnly}
                autoFocus={autofocus}
                inputMode={inputMode!}
                onBlur={onBlur}
                onKeyDown={e => {
                    if(e.code === 'Enter') {
                        onReturnPressed?.();
                    }
                }}
            />
        </div>
    );
};

export default BasicTextInput